import { ClubPlan, SubPlan, SubscriptionStatus, UserPlan } from "../enums";

/** Joueur premium (Joueur Plus) — plan check only, ignores status */
export function isUserPremium(userPlan: string | null | undefined): boolean {
  return userPlan === UserPlan.PLUS;
}

/** Club premium (Club Pro) — plan check only, ignores status */
export function isClubPremium(clubPlan: string | null | undefined): boolean {
  return clubPlan === ClubPlan.PRO;
}

/**
 * Joueur Plus réellement actif : plan = PLUS ET subscriptionStatus = ACTIVE.
 * Tout autre cas (CANCELED, PAST_DUE, UNPAID, null, undefined) → Free.
 *
 * NOTE typing : `subscriptionStatus` typé `string | null | undefined`
 * (et non `SubscriptionStatus`) volontairement, pour compatibilité
 * cross-package. L'enum `SubscriptionStatus` généré par Prisma
 * (`@prisma/client`) est nominalement distinct de celui déclaré dans
 * `@shared/enums` malgré des valeurs identiques (TS enums = types
 * nominaux). Accepter `string` permet aux deux callers (API Prisma +
 * admin shared) d'appeler le helper sans cast. La comparaison stricte
 * `=== SubscriptionStatus.ACTIVE` ci-dessous filtre la valeur exacte,
 * donc la sémantique reste "ceinture stricte" (aucun statut hors
 * `'ACTIVE'` ne passe à `true`). Même pattern déjà retenu pour `plan`.
 */
export function isUserPlusActive(
  userPlan: string | null | undefined,
  subscriptionStatus: string | null | undefined,
): boolean {
  return (
    userPlan === UserPlan.PLUS &&
    subscriptionStatus === SubscriptionStatus.ACTIVE
  );
}

/**
 * Club Pro réellement actif : plan = PRO ET subscriptionStatus = ACTIVE.
 * Tout autre cas (CANCELED, PAST_DUE, UNPAID, null, undefined) → Free.
 *
 * NOTE typing : voir `isUserPlusActive` ci-dessus pour la justification
 * du `string | null | undefined` sur `subscriptionStatus`.
 */
export function isClubProActive(
  clubPlan: string | null | undefined,
  subscriptionStatus: string | null | undefined,
): boolean {
  return (
    clubPlan === ClubPlan.PRO &&
    subscriptionStatus === SubscriptionStatus.ACTIVE
  );
}

/**
 * Forfait réellement actif : plan = FORFAIT ET subscriptionStatus = ACTIVE.
 * Tout autre cas (CANCELED, PAST_DUE, UNPAID, null, undefined) → Commission.
 *
 * NOTE typing : voir `isUserPlusActive` ci-dessus pour la justification
 * du `string | null | undefined` sur `subscriptionStatus`.
 */
export function isOrgaForfaitActive(
  plan: string | null | undefined,
  subscriptionStatus: string | null | undefined,
): boolean {
  return (
    plan === SubPlan.FORFAIT && subscriptionStatus === SubscriptionStatus.ACTIVE
  );
}
